<template>
  <v-container fluid fill-height>
    <v-slide-y-transition mode="out-in">
      <v-layout row wrap>
        <v-flex d-flex xs12>
          <v-layout column>
            <v-flex d-flex>
              <v-card style="margin-top:20px">
                <v-card-text>
                  <h3 style="text-align: left;margin-bottom: 10px">Address Book</h3>
                  <v-divider divider: true></v-divider>
                  <v-layout row wrap>
                    <p style="margin-top:20px;text-align: left">Use the address book to keep track of parties you do business with new companies can be added when you click a button "Add  Address". An existing company can be updated for other party types or can be deleted by moving in action panel</p>
                                  <v-dialog
                                    v-model="dialog"
                                    width="800"
                                  >
                                  <v-btn class="primary" style="margin-left:700px;margin-top: 10px" slot="activator">Add Address</v-btn>
                                    <v-card>
                                      <v-card-title
                                        class="headline lighten-2"
                                        primary-title
                                        style="color:#1565C0"
                                      >
                                        Add Party
                                      </v-card-title>
                                      <v-divider></v-divider>
                                      <v-card-text>
                                        <v-layout row wrap>
                                          <v-flex xs12>
                                            <v-layout row wrap>
                                              <v-flex xs2></v-flex>
                                              <v-flex xs6 style="margin-left:80px">
                                                <label style="text-align: left">Company</label>
                                                <v-text-field
                                                  label=""
                                                  outline
                                                 ></v-text-field>
                                                <label style="text-align: left">Address</label>
                                                 <v-textarea
                                                  outline
                                                  name="input"
                                                  label=""
                                                  value=""
                                                  style="margin-top:10px;"
                                                ></v-textarea>
                                                <label style="text-align: left">Type</label>
                                                <v-overflow-btn
                                                :items="dropdown_list"
                                                label="Please Select"
                                                target="#dropdown-example"
                                                style="margin-top:10px;"
                                                outline
                                                ></v-overflow-btn>
                                              </v-flex>
                                              <v-flex xs2></v-flex>
                                            </v-layout>
                                          </v-flex>
                                        </v-layout>
                                      </v-card-text>
                                      <v-divider></v-divider>
                                      <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <v-btn
                                          color="primary"
                                          flat
                                          @click="dialog = false"
                                        >
                                          Cancel
                                        </v-btn>
                                        <v-btn
                                          color="primary"
                                          @click="dialog = false"
                                        >
                                          Create Party
                                        </v-btn>
                                      </v-card-actions>
                                    </v-card>
                                  </v-dialog>
                      <v-btn class="primary" style="margin-left:30px;margin-top: 10px" v-on:click="bulkupload()">Bulk Upload</v-btn>
                  </v-layout>
                  <v-divider divider: true></v-divider>
                  <h3 style="text-align: left;margin-bottom: 10px;margin-top:20px">Address Book List</h3>
                  <v-layout row wrap>
                    <v-flex xs3 child-flex>
                      <v-layout row wrap>
                        <label style="margin-top:20px;margin-right: 10px">Show</label>
                        <v-overflow-btn
                          :items="dropdown_list"
                          label=""
                          target="#dropdown-example"
                        ></v-overflow-btn>
                        <label style="margin-top:20px;margin-left: 10px">Entries</label>
                      </v-layout>
                    </v-flex>
                    <v-flex xs3 child-flex></v-flex>
                    <v-flex xs6 child-flex>
                      <v-layout row wrap>
                        <v-text-field
                          label="Search"
                        ></v-text-field>
                        <v-btn class="primary" flat style="margin-top:10px;"><v-icon dark>search</v-icon></v-btn>
                      </v-layout>
                    </v-flex>
                  </v-layout>
                  <v-data-table
                    :headers="headers"
                    :items="desserts"
                    class="elevation-1"
                  >
                    <template slot="items" slot-scope="props">
                      <td>{{ props.item.no}}</td>
                      <td class="text-xs-left">{{ props.item.company}}</td>
                      <td class="text-xs-left">{{ props.item.address}}</td>
                      <td class="text-xs-left">{{ props.item.type}}</td>
                      <td class="text-xs-left"><v-layout row wrap><v-btn class="primary" @click="dialog1 = true" style="margin-right:20px">Update</v-btn> | <v-switch v-model="switch1" style="margin-left:20px"></v-switch></v-layout></td>
                    </template>
                  </v-data-table>
                                  <v-dialog
                                    v-model="dialog1"
                                    width="800"
                                  >
                                    <v-card>
                                      <v-card-title
                                        class="headline lighten-2"
                                        primary-title
                                        style="color:#1565C0"
                                      >
                                        Update Party
                                      </v-card-title>
                                      <v-divider></v-divider>
                                      <v-card-text>
                                        <v-layout row wrap>
                                          <v-flex xs12>
                                            <v-layout row wrap>
                                              <v-flex xs2></v-flex>
                                              <v-flex xs6 style="margin-left:80px">
                                                <label style="text-align: left">Company</label>
                                                <v-text-field
                                                  label=""
                                                  outline
                                                 ></v-text-field>
                                                <label style="text-align: left">Address</label>
                                                 <v-textarea
                                                  outline
                                                  name="input"
                                                  label=""
                                                  value=""
                                                  style="margin-top:10px;"
                                                ></v-textarea>
                                                <label style="text-align: left">Type</label>
                                                <v-overflow-btn
                                                :items="dropdown_list"
                                                label="Please Select"
                                                target="#dropdown-example"
                                                style="margin-top:10px;"
                                                outline
                                                ></v-overflow-btn>
                                              </v-flex>
                                              <v-flex xs2></v-flex>
                                            </v-layout>
                                          </v-flex>
                                        </v-layout>
                                      </v-card-text>
                                      <v-divider></v-divider>
                                      <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <v-btn
                                          color="primary"
                                          flat
                                          @click="dialog1 = false"
                                        >
                                          Cancel
                                        </v-btn>
                                        <v-btn
                                          color="primary"
                                          @click="dialog1 = false"
                                        >
                                          Update
                                        </v-btn>
                                      </v-card-actions>
                                    </v-card>
                                  </v-dialog>
                  </v-card-text>
              </v-card>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
    </v-slide-y-transition>
  </v-container>
</template>

<script>
export default {
  data () {
    return {
      dropdown_list: [1, 2, 3, 4, 5],
      headers: [
        {
          text: '#',
          align: 'left',
          value: 'no'
        },
        { text: 'Company', value: 'company' },
        { text: 'Address', value: 'address' },
        { text: 'Type', value: 'type' },
        { text: 'Container Type', value: 'containertype' }
      ],
      desserts: [
        {
          no: '1',
          company: '',
          address: '',
          type: ''
        },
        {
          no: '2',
          company: '',
          address: '',
          type: ''
        },
        {
          no: '3',
          company: '',
          address: '',
          type: ''
        }
      ],
      switch1: true,
      dialog: false,
      dialog1: false
    }
  },
  mounted () {
    console.log('wynumtrack page')
  },
  methods: {
    sho1 () {
      this.show1 = true
      this.show2 = false
      this.show3 = false
    },
    sho2 () {
      this.show2 = true
      this.show1 = false
      this.show3 = false
    },
    sho3 () {
      this.show3 = true
      this.show2 = false
      this.show1 = false
    },
    bulkupload () {
      this.$router.push('/Addressbulkupload')
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}

</style>



// WEBPACK FOOTER //
// src/components/Addressbook.vue